/* eslint no-undef: 0 */
// import 'babel-polyfill';

// Bootstrap dependencies
// import 'popper.js';
// import 'bootstrap/js/dist/alert';
import 'bootstrap/js/dist/button';
import 'bootstrap/js/dist/carousel';
import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/dropdown';
// import 'bootstrap/js/dist/modal';
// import 'bootstrap/js/dist/popover';
// import 'bootstrap/js/dist/scrollspy';
// import 'bootstrap/js/dist/tab';
// import 'bootstrap/js/dist/toast';
// import 'bootstrap/js/dist/tooltip';
import 'bootstrap/js/dist/util';

// FontAwesome
import '@fortawesome/fontawesome-free/js/regular';
import '@fortawesome/fontawesome-free/js/solid';
import '@fortawesome/fontawesome-free/js/brands';
import '@fortawesome/fontawesome-free/js/fontawesome';

// Vendor
import 'headspace/dist/headspace';

// Custom Scripts
import './scripts';
import './main-nav-controller';
// import './facet-wp-infinite-scroll';



// WEBPACK FOOTER //
// ./src/js/app.js